import React from "react";

import { MetaTags } from "react-meta-tags";
import {
  Breadcrumbs,
  DashBreadcrumb,
} from "../../components/Common/Breadcrumb";
//../../../components/Common/Breadcrumb
import {
    Col,
    Container,
    Row,
    FormGroup, 
    InputGroup, 
  } from "reactstrap";

import ListRejectedComponent from "./components/StoreSelection/ListRejected.component";
const ManageRejectedQueue = () => {
  const title = "Queue List";
  const description = "Rejected Queue List";
  return (
    <React.Fragment> 
      <div className="page-content">
        <MetaTags>
          <title>Cancel Request</title>
        </MetaTags>
        <Container fluid>
          {/* Render Breadcrumbs */}
          <Row>
            <Col xl={6}>
              <DashBreadcrumb title="Queue List" breadcrumbItem="Manage Rejected Cancel Request" />
            </Col>
          </Row>
         <ListRejectedComponent></ListRejectedComponent>
        </Container>
      </div>
    </React.Fragment>
  );
};
export default ManageRejectedQueue;
